import { render, staticRenderFns } from "./faceMonitor3.vue?vue&type=template&id=17a5f738&"
import script from "./faceMonitor3.vue?vue&type=script&lang=js&"
export * from "./faceMonitor3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports